/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"
import type {
	MarketingMediaUploadResponse,
	MessagePreviewImagePart,
	MessagePreviewLinkPart,
	MessagePreviewPlaceholderPart,
	MessagePreviewResponse,
	MessagePreviewTextPart,
	MessageVariablesResponse,
} from ".././types/marketing"
import { MessageVariableKind } from ".././types/marketing"

export const getGetMarketingMessageVariablesResponseMock = (
	overrideResponse: Partial<Extract<MessageVariablesResponse, object>> = {},
): MessageVariablesResponse => ({
	variables: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		key: "name",
		token: "{имя}",
		label: "имя",
		kind: faker.helpers.arrayElement(Object.values(MessageVariableKind)),
		insertable: faker.datatype.boolean(),
	})),
	...overrideResponse,
})

export const getPreviewMarketingMessageResponseMessagePreviewTextPartMock = (
	overrideResponse: Partial<MessagePreviewTextPart> = {},
): MessagePreviewTextPart => ({
	...{
		type: faker.helpers.arrayElement(["text"] as const),
		content: faker.string.alpha({ length: { min: 10, max: 20 } }),
	},
	...overrideResponse,
})

export const getPreviewMarketingMessageResponseMessagePreviewLinkPartMock = (
	overrideResponse: Partial<MessagePreviewLinkPart> = {},
): MessagePreviewLinkPart => ({
	...{
		type: faker.helpers.arrayElement(["link"] as const),
		url: faker.internet.url(),
	},
	...overrideResponse,
})

export const getPreviewMarketingMessageResponseMessagePreviewImagePartMock = (
	overrideResponse: Partial<MessagePreviewImagePart> = {},
): MessagePreviewImagePart => ({
	...{
		type: faker.helpers.arrayElement(["image"] as const),
		url: faker.internet.url(),
	},
	...overrideResponse,
})

export const getPreviewMarketingMessageResponseMessagePreviewPlaceholderPartMock =
	(
		overrideResponse: Partial<MessagePreviewPlaceholderPart> = {},
	): MessagePreviewPlaceholderPart => ({
		...{
			type: faker.helpers.arrayElement(["placeholder"] as const),
			token: faker.string.alpha({ length: { min: 10, max: 20 } }),
			label: faker.string.alpha({ length: { min: 10, max: 20 } }),
			kind: faker.helpers.arrayElement(Object.values(MessageVariableKind)),
		},
		...overrideResponse,
	})

export const getPreviewMarketingMessageResponseMock = (
	overrideResponse: Partial<Extract<MessagePreviewResponse, object>> = {},
): MessagePreviewResponse => ({
	charCount: 84,
	parts: 2,
	estimatedBillableMessages: faker.helpers.arrayElement([
		faker.number.int(),
		null,
	]),
	previewText: faker.helpers.arrayElement([
		faker.string.alpha({ length: { min: 10, max: 20 } }),
		null,
	]),
	previewMediaUrl: faker.helpers.arrayElement([faker.internet.url(), null]),
	previewParts: faker.helpers.arrayElement([
		Array.from(
			{ length: faker.number.int({ min: 1, max: 5 }) },
			(_, i) => i + 1,
		).map(() =>
			faker.helpers.arrayElement([
				{ ...getPreviewMarketingMessageResponseMessagePreviewTextPartMock() },
				{ ...getPreviewMarketingMessageResponseMessagePreviewLinkPartMock() },
				{ ...getPreviewMarketingMessageResponseMessagePreviewImagePartMock() },
				{
					...getPreviewMarketingMessageResponseMessagePreviewPlaceholderPartMock(),
				},
			]),
		),
		undefined,
	]),
	...overrideResponse,
})

export const getUploadMarketingMediaResponseMock = (
	overrideResponse: Partial<Extract<MarketingMediaUploadResponse, object>> = {},
): MarketingMediaUploadResponse => ({
	mediaId: faker.string.alpha({ length: { min: 10, max: 20 } }),
	url: faker.internet.url(),
	...overrideResponse,
})

export const getGetMarketingMessageVariablesMockHandler = (
	overrideResponse?:
		| MessageVariablesResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MessageVariablesResponse> | MessageVariablesResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/messages/variables",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingMessageVariablesResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getPreviewMarketingMessageMockHandler = (
	overrideResponse?:
		| MessagePreviewResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<MessagePreviewResponse> | MessagePreviewResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/messages/preview",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getPreviewMarketingMessageResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getUploadMarketingMediaMockHandler = (
	overrideResponse?:
		| MarketingMediaUploadResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) =>
				| Promise<MarketingMediaUploadResponse>
				| MarketingMediaUploadResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/media",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getUploadMarketingMediaResponseMock(),
				{ status: 201 },
			)
		},
		options,
	)
}
export const getMarketingMessagesMock = () => [
	getGetMarketingMessageVariablesMockHandler(),
	getPreviewMarketingMessageMockHandler(),
	getUploadMarketingMediaMockHandler(),
]
